export default "__VITE_ASSET__ce977d02__"